import {
  Flame,
  Dumbbell,
  Repeat,
  Zap,
  Infinity as InfinityIcon,
  Timer,
  Hourglass,
  Bike,
} from 'lucide-react';
import type { BlockType, Discipline } from '../types';

interface BlockTypeMeta {
  label: string;
  icon: React.ElementType;
  description: string;
}

export const blockTypeMeta: Record<BlockType, BlockTypeMeta> = {
  warmup: { label: 'Entrada en Calor', icon: Flame, description: 'Activación y movilidad' },
  exercise: { label: 'Ejercicios', icon: Dumbbell, description: 'Ejercicios principales del día' },
  circuit: { label: 'Circuito', icon: Repeat, description: 'Varios ejercicios en secuencia' },
  superset: { label: 'Super Serie', icon: Zap, description: 'Dos o más ejercicios sin descanso' },
  amrap: { label: 'AMRAP', icon: InfinityIcon, description: 'Máximas rondas en un tiempo dado' },
  emom: { label: 'EMOM', icon: Timer, description: 'Cada minuto, al minuto' },
  for_time: { label: 'For Time', icon: Hourglass, description: 'Completar lo antes posible' },
  interval: { label: 'Intervalos', icon: Bike, description: 'Bloques de trabajo/descanso por tiempo' },
};

// Tipos universales (cualquier disciplina) + extras por disciplina.
const UNIVERSAL: BlockType[] = ['warmup', 'exercise', 'circuit', 'superset'];
const BY_DISCIPLINE: Partial<Record<Discipline, BlockType[]>> = {
  crossfit: ['amrap', 'emom', 'for_time'],
  hybrid: ['amrap', 'emom', 'for_time', 'interval'],
  cardio: ['interval'],
};

/** Tipos de bloque que se ofrecen al armar un plan de esta disciplina. */
export function blockTypesForDiscipline(discipline?: Discipline | null): BlockType[] {
  return [...UNIVERSAL, ...(discipline ? BY_DISCIPLINE[discipline] ?? [] : [])];
}
